export { EloStarSelectedIcon } from './star-selected-icon'
